// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RVgJ","buttons":"styles_buttons__BJbgj"};